import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { stateConvert } from 'web/components/utils/stateAbbreviation';
import { adminUpdateUserApi, checkIsValidEmail, checkIsZipCode } from 'redux/actions/adminPtPlus/index';
import { Container, AccordionHeader, AccordionBody, InputFieldsWrapper } from '.././PTPlusStyled'
import { storeAdminDetails, logoutAdmin} from 'redux/actions/admin';
import TextInput from 'web/components/form-elements/TextInput';
import PhoneNumber from 'web/components/form-elements/PhoneNumber';
import NumberInput from 'web/components/form-elements/NumberInput';
import EditIcon from "web/assets/svg/PtPlusUserViewEditIcon";
import { Tooltip } from 'reactstrap';
import information from "web/assets/images/informationIcon.png";

import AlertModal from 'web/components/AlertModal';

function BillTo(pageProps) {
    const dispatch = useDispatch();
    let history = useHistory()
    const [saveDisableState, setSaveDisableState] = useState(true)
    const [isValidEmail, setIsValidEmail] = useState(true)
    const [isValidZip, setIsValidZip] = useState(true)
    const [accordionOpen, setAccordionOpen] = useState(false)
    const [alertModal, setAlertModal] = useState(false);
    const [alertModalContent, setAlertModalContent] = useState('');
    let pageFieldValues = pageProps.formikProps.values
    useEffect(() => {
        let fieldValues = pageProps.formikProps.values
        if (!pageProps.formikProps.errors.billToPhoneNumber && !pageProps.formikProps.errors.billToEmail && !pageProps.formikProps.errors.otherToEmail && isValidZip && fieldValues.billToUserName.trim() !== '' && fieldValues.billToPhoneNumber.trim() !== '' && fieldValues.billToBusinessName.trim() !== '' && fieldValues.billToEmail.trim() &&
            fieldValues.billToAddress.trim() !== '' && fieldValues.billToCity.trim() !== '' && fieldValues.billToState.trim() !== '' && fieldValues.billToZip.trim() !== '' && parseInt(fieldValues.billToZip) > 0) {
            setSaveDisableState(false)
        } else setSaveDisableState(true)
    }, [pageProps.formikProps, isValidEmail, isValidZip])

    const [tooltip, setTooltip] = useState(false);
    const [tooltipSection, setTooltipSection] = useState('');
    const iIcon = (infoSection, infoTxt) => {
        return <>
            <img
                id={infoSection}
                src={information}
                style={{ position: "relative", top: "2px", left: '-5px' }}
            />
            <Tooltip
                placement="right"
                isOpen={tooltip && tooltipSection === infoSection}
                target={infoSection}
                toggle={() => {
                    setTooltip(!tooltip)
                    setTooltipSection(tooltipSection === '' ? infoSection : '')
                }
                }
            >
                {infoTxt}
            </Tooltip>
        </>
    }

    const updateApiFunction = async () => {
        let id = pageProps.pageData.id
        let url = `ptms/internal/bill_to_update/${id}`
        let fieldValues = pageProps.formikProps.values
        let response = '';
        let data = {
            billToEmailAddress: fieldValues.billToEmail?.trim(),
            otherContactEmail: fieldValues.otherToEmail ? fieldValues.otherToEmail.trim() : null,
            address: {
                name: fieldValues.billToUserName?.trim(),
                contactNumber: fieldValues.billToPhoneNumber?.trim(),
                locationName: fieldValues.billToBusinessName?.trim(),
                street: fieldValues.billToAddress?.trim(),
                city: fieldValues.billToCity?.trim(),
                state: fieldValues.billToState?.trim(),
                zipCode: fieldValues.billToZip?.trim()
            }
        }

        pageProps.pageData.billToEmailAddress = fieldValues.billToEmail?.trim()
        const token = localStorage.getItem('token')
        response = await dispatch(adminUpdateUserApi(url, data, token))
        if (response.success) {
            setAlertModalContent('Detail has been updated successfully.')
            setAlertModal(!alertModal)
        } else {
            if (response.statusCode === 401) {
                adminLogout()
            } else {
                setAlertModalContent(response.message)
                setAlertModal(!alertModal)
            }
        }
    }

    
    const adminLogout = () => {
        dispatch(storeAdminDetails([], {}))
        dispatch(logoutAdmin())
        localStorage.removeItem('adminRolesData')
        localStorage.removeItem('adminName')
        localStorage.removeItem('adminEmail')
        localStorage.removeItem('token')
        history.push('./sign-in')
    }
    const zipChangeHandler = async (value) => {
        const token = localStorage.getItem('token')
        let response = '';
        if (value.length === 5) {
            response = await dispatch(checkIsZipCode(value, token))
            if (response.success) {
                setIsValidZip(true)
                let stateAbb = stateConvert(response.data?.state)
                pageProps.setFieldValue('billToState', stateAbb || response.data?.state)
                pageProps.setFieldValue('billToCity', response.data?.city)
            } else {
                if (response?.data?.error?.message === 'Invalid Zip Code.') {
                    setIsValidZip(false)
                    pageProps.setFieldValue('billToState', '')
                    pageProps.setFieldValue('billToCity', '')
                } else if (response.statusCode === 401) {
                    adminLogout()
                } else {
                    setAlertModalContent(response.message || 'Something went wrong, please try again.')
                    setAlertModal(!alertModal)
                }
            }
        } else {
            setIsValidZip(true)
            pageProps.setFieldValue('billToState', '')
            pageProps.setFieldValue('billToCity', '')
        }
    }

    const resetFieldsFunction = () => {
        const initailData = pageProps.pageData
        pageProps.setFieldValue('billToBusinessName', initailData?.billingAddress?.locationName || '')
        pageProps.setFieldValue('billToAddress', initailData?.billingAddress?.street)
        pageProps.setFieldValue('billToCity', initailData?.billingAddress?.city)
        pageProps.setFieldValue('billToState', initailData?.billingAddress?.state)
        pageProps.setFieldValue('billToZip', initailData?.billingAddress?.zipCode)
        pageProps.setFieldValue('billToPhoneNumber', initailData?.billingAddress?.contactNumber || '')
        pageProps.setFieldValue('billToUserName', initailData.billingAddress?.name)
        pageProps.setFieldValue('billToEmail', initailData?.billToEmailAddress || '')
        pageProps.setFieldValue('otherToEmail', initailData?.otherContactEmail || '')
    }

    return (
        <>
            <Container>
                <AccordionHeader>
                    <h6 onClick={() => {
                        if(accordionOpen) setAccordionOpen(false)
                        else setAccordionOpen(true)
                    }}>Bill-To Information</h6>
                    {accordionOpen ?
                        <h4 onClick={() => setAccordionOpen(false)}><i></i></h4>
                        : <h5 onClick={() => setAccordionOpen(true)}><i></i></h5>
                    }
                </AccordionHeader>
                {accordionOpen &&
                    <AccordionBody>
                        <InputFieldsWrapper>
                            <div className="row">
                                <div className="col-md-4 fixed-height">
                                    {pageFieldValues.billToBusinessName !== '' && <h6>Company Name<span className='star'>&#42;</span></h6>}
                                    <div className='height-adjust'><TextInput name='billToBusinessName' placeholder={`Company Name*`} inputType='companyAndLocationText' /></div>
                                </div>
                                <div className="col-md-4 fixed-height">
                                    {pageFieldValues.billToAddress !== '' && <h6>Address<span className='star'>&#42;</span></h6>}
                                    <div className='height-adjust'><TextInput name='billToAddress' placeholder={`Address*`} maxLength={200}/></div>
                                </div>
                                <div className="col-md-4 fixed-height">
                                    {pageFieldValues.billToCity !== '' && <h6>City<span className='star'>&#42;</span></h6>}
                                    <div className='height-adjust'><TextInput name="billToCity" placeholder={`City*`} inputType='text' /></div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4 fixed-height">
                                    {pageFieldValues.billToState !== '' && <h6 className='mb-2'>State<span className='star'>&#42;</span></h6>}
                                    <div className='height-adjust'><TextInput name="billToState" placeholder={`State*`} disabled inputType='text' /></div>
                                </div>
                                <div className={!isValidZip ? 'col-md-4 fixed-height error-styling-input' : 'col-md-4 fixed-height'}>
                                    {pageFieldValues.billToZip !== '' && <h6 className='mb-2'>Zip<span className='star'>&#42;</span></h6>}
                                    <div className='height-adjust'><NumberInput name="billToZip" placeholder={`Zip*`} maxLength={5} callBackFlag={true} callBackFun={zipChangeHandler} />
                                        {!isValidZip && <p style={{ marginTop: '-12px' }}>Zipcode is invalid.</p>}
                                    </div>
                                </div>
                                <div className="col-md-4 fixed-height">
                                    {pageFieldValues.billToPhoneNumber !== '' && <h6>Billing Contact Phone Number<span className='star'>&#42;</span></h6>}
                                    <div className='height-adjust'><PhoneNumber name="billToPhoneNumber" placeholder={`Billing Contact Phone Number*`} /></div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4 fixed-height">
                                    {pageFieldValues.billToUserName !== '' && <h6>Billing Contact Full Name<span className='star'>&#42;</span></h6>}
                                    <div className='height-adjust'><TextInput name='billToUserName' placeholder={`Billing Contact Full Name*`} inputType='text' /></div>
                                </div>
                                <div className={!isValidEmail ? 'col-md-4 fixed-height error-styling-input' : 'col-md-4 fixed-height'}>
                                    {pageFieldValues.billToEmail !== '' && <h6>Billing Contact Email<span className='star'>&#42;</span></h6>}
                                    <div className='height-adjust' style={{ display: 'grid', gridTemplateColumns: '15fr 1fr' }}>
                                        <div>
                                            <TextInput name="billToEmail" placeholder={`Billing Contact Email*`} />
                                            {!isValidEmail && <p style={{ marginTop: '-7px' }}>Email already exists.</p>}
                                        </div>
                                        <div>
                                            {iIcon('billToEmail', 'Email contact of person that should receive invoicing.')}
                                        </div>
                                    </div>
                                </div>
                                <div className={!isValidEmail ? 'col-md-4 fixed-height error-styling-input' : 'col-md-4 fixed-height'}>
                                    {pageFieldValues.billToEmail !== '' && <h6>Other Contact Email</h6>}
                                    <div className='height-adjust' style={{ display: 'grid', gridTemplateColumns: '15fr 1fr' }}>
                                        <div>
                                            <TextInput name="otherToEmail" placeholder={`Other Contact Email`} />
                                            {!isValidEmail && <p style={{ marginTop: '-7px' }}>Email already exists.</p>}
                                        </div>
                                        {/* <div>
                                            {iIcon('otherToEmail', 'Email contact of person that should receive invoicing.')}
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </InputFieldsWrapper>
                        <div className='view-edit-button-section'>
                            <button className={saveDisableState ? 'save-button disabled' : 'save-button'} disabled={saveDisableState} onClick={() => updateApiFunction()}><EditIcon />Update</button>
                            <button className='cancel-button' onClick={() => resetFieldsFunction()}>Cancel</button>
                        </div>
                    </AccordionBody>
                }
            </Container>

            <AlertModal
                isOpen={alertModal}
                toggle={() => setAlertModal(!alertModal)}
                title=''
                content={alertModalContent}
            />
        </>
    )
}

export default BillTo